import { Pipe, PipeTransform, inject } from '@angular/core';

import { LocaleService } from '@next/core-lib/i18n';

import { Product, ProductArticleName } from '../models';

@Pipe({
  name: 'articleNameTranslation',
  pure: false,
  standalone: false,
})
export class ArticleNameTranslationPipe implements PipeTransform {
  private readonly locale = inject(LocaleService);

  transform(items: ProductArticleName[], cropAid: Product): string {
    if (!items) {
      return;
    }

    const language = this.locale.getLocale();
    const translatedName = items.find((articleName) => articleName.language.toLocaleLowerCase() === language.toLocaleLowerCase())?.title;

    if (!translatedName) {
      if (!items[0]?.title) {
        return cropAid.name;
      }
      //Default to EN translation if there is no article name for NL
      return items[0]?.title;
    }

    return translatedName;
  }
}
